import { render, staticRenderFns } from "./DeveloperTool.vue?vue&type=template&id=b97a584e&"
import script from "./DeveloperTool.vue?vue&type=script&lang=js&"
export * from "./DeveloperTool.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperTool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports